import { useRef, useState, useCallback } from "react";

export default function BeforeAfter({ before, after, title, location }) {
    const [pos, setPos] = useState(50);
    const ref = useRef(null);
    const dragging = useRef(false);

    const move = useCallback((clientX) => {
        const rect = ref.current?.getBoundingClientRect();
        if (!rect) return;
        const pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
        setPos(pct);
    }, []);

    return (
        <figure
            ref={ref}
            className="relative w-full aspect-[4/3] overflow-hidden bg-coal cursor-ew-resize border border-linew"
            data-testid="before-after"
            onMouseDown={(e) => { dragging.current = true; move(e.clientX); }}
            onMouseUp={() => { dragging.current = false; }}
            onMouseLeave={() => { dragging.current = false; }}
            onMouseMove={(e) => { if (dragging.current) move(e.clientX); }}
            onTouchStart={(e) => move(e.touches[0].clientX)}
            onTouchMove={(e) => move(e.touches[0].clientX)}
        >
            <img
                src={after}
                alt={`${title} — après travaux`}
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
                data-testid="after-image"
            />
            <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
                <img
                    src={before || after}
                    alt={`${title} — avant travaux`}
                    className="absolute inset-0 w-full h-full object-cover grayscale-[0.4] brightness-[0.85]"
                    loading="lazy"
                    data-testid="before-image"
                />
            </div>

            <span className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.25em] bg-ink/80 text-ivory px-3 py-1.5 border border-linew">
                Avant
            </span>
            <span className="absolute top-4 right-4 text-[10px] uppercase tracking-[0.25em] bg-gold text-ink font-bold px-3 py-1.5">
                Après
            </span>

            <div
                className="absolute top-0 bottom-0 w-px bg-gold shadow-[0_0_18px_rgba(212,175,55,0.8)]"
                style={{ left: `${pos}%` }}
            >
                <span className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-9 h-9 rounded-full bg-gold text-ink flex items-center justify-center text-sm font-bold">
                    ↔
                </span>
            </div>

            <figcaption className="absolute bottom-0 inset-x-0 flex items-end justify-between gap-4 p-5 bg-gradient-to-t from-ink/90 to-transparent">
                <span className="text-ivory font-medium text-sm sm:text-base">{title}</span>
                {location && (
                    <span className="text-gold text-xs uppercase tracking-[0.2em] shrink-0">{location}</span>
                )}
            </figcaption>
        </figure>
    );
}
